import VimeoEmbed from "../vimeo/vimeo";

export const VideoSection = () => {
  return (
    <section className="section-sp2" style={{ paddingInline: "30px" }}>
      <div className="container inner-content">
        <h2 style={{ textAlign: "center" }}>
          New to HCP Targeting using NPI Targeting?
        </h2>
        <p style={{ textAlign: "center" }}>
          Learn more about unlocking the secrets of NPI audience targeting in
          our exclusive webinar.
        </p>
        <div style={{ maxWidth: "980px", margin: "auto" }}>
          <VimeoEmbed url="https://vimeo.com/1069779201/a13f39b19d?share=copy" />
        </div>
      </div>
    </section>
  );
};
